module.exports = __webpack_public_path__ + "static/media/Group 10446.7a11b94e.svg";